module.exports = __webpack_public_path__ + "img/dayin.83bd1638.png";